module.exports = __webpack_public_path__ + "static/media/2DGACM8.e5126302.jpg";